export default __webpack_public_path__ + "static/media/Ellipse 2.7d40dbea.png";